import { useContext } from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps } from '@mantine/core'
import { useIntl } from 'react-intl'

import { CarouselOrListingBlockContext } from './context'
import { useSlideInfo } from './useSlideInfo'

export const Paging = (boxProps: BoxProps) => {
  const { formatMessage: f } = useIntl()
  const { filteredChild, embla } = useContext(CarouselOrListingBlockContext)
  const { slideInfo } = useSlideInfo(embla, filteredChild.length)
  return filteredChild.length > 0 && slideInfo ? (
    <Box {...boxProps}>
      <Text size="p3">
        {f(
          { id: 'category.title' },
          {
            total: slideInfo.totalSlide,
            number: <strong>{slideInfo.currentSlide + 1}</strong>,
          },
        )}
      </Text>
    </Box>
  ) : null
}
